import { type Tenants } from '@gp/base'

import { apiClient } from '@/api/client'

import type { GameIDs } from './types'

interface SetAgreementsPayload {
  date_agreement_participation: string
}

export const setAgreements = async (
  network: Tenants,
  gameId: GameIDs = 'esum',
): Promise<void> => {
  const body: SetAgreementsPayload = {
    date_agreement_participation: new Date().toISOString(),
  }

  await apiClient.instance.patch(`/v1/${gameId}/agreements`, body, {
    params: { network },
  })
}
